import { ReactElement, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextArea from 'common/components/textArea';
import { selectMergeReason, setMergeReason } from '../slice';
import useTexts from '../hooks/useTexts';
import { StyledFieldLabel, MergeReasonWrapper, StyledAsterisk } from '../style';

const MergeReason = (): ReactElement => {
  const dispatch = useDispatch();
  const mergeReason = useSelector(selectMergeReason);

  const { mergeReasonLabel, mergeReasonPlaceholder } = useTexts();

  const changeMergeReason = useCallback((value: string) => {
    dispatch(setMergeReason(value));
  }, [dispatch]);

  return (
    <MergeReasonWrapper>
      <StyledFieldLabel>
        {mergeReasonLabel} <StyledAsterisk />
      </StyledFieldLabel>
      <TextArea
        value={mergeReason || ''}
        setValue={changeMergeReason}
        placeholder={mergeReasonPlaceholder}
        testId="merge-reason"
        maxRows={4}
      />
    </MergeReasonWrapper>
  );
};

export default MergeReason;
